import Confirm from './Confirm';
import Review from './Review';
import CoContributionsWizard from './Wizard';

export { Confirm, Review };

export default CoContributionsWizard;
